export var DEPLOY_DATE = new Date('2026-10-21T18:07:13+0000');
